import { CheckoutStatus } from 'types/typescript'

export const STATUS: CheckoutStatus = {
  ERROR: -1,
  NOT_STARTED: 0,
  PENDING: 4,
  QUEUED: 5,
  REDIRECTING: 10,
  REQUESTED: 1
}
